import { useTranslation } from 'next-i18next'
import { Text, FlexProps, Flex } from '@chakra-ui/react'
import { FC } from 'react'
import {
  CustomizableEngraveCartItem,
  PaidOptions,
} from 'modules/checkout/components/PaidOptions'
import { PriceText } from '_app/components'
import { Money } from '_app/types/api'

interface CartOptionHeaderProps extends FlexProps {
  option?: string;
  value?: string;
  isPaintingOrEngraving?: boolean;
  cartItem?: CustomizableEngraveCartItem;
  isDrawerMode?: boolean;
  price?: number;
}

const CartOptionHeader: FC<CartOptionHeaderProps> = ({
  option,
  value,
  isPaintingOrEngraving,
  cartItem,
  isDrawerMode = false,
  price,
  ...props
}) => {
  const convertValue = (text: string) => {
    const uselessWords = ['title', 'qty', 'price'].join('|')

    return text
      ?.replace(new RegExp('\\b(' + uselessWords + ')\\b', 'gi'), ' ')
      .replace(/\s{2,}/g, ' ')
      .split(':')
  }

  const convertedValue = value?.includes('title') ? convertValue(value) : value

  return (
    <Flex
      justifyContent="flex-start"
      width="100%"
      flexDirection="row"
      {...props}
    >
      {!isPaintingOrEngraving && option && (
        <Text textStyle="productDetail" whiteSpace="nowrap" mr={4}>
          {option}:
        </Text>
      )}
      {cartItem ? (
        <PaidOptions
          cartItem={cartItem}
          isShowEngravingTitle
          isDrawerMode={isDrawerMode}
        />
      ) : (
        <Flex
          justifyContent="space-between"
          w="100%"
          pr={{ base: 0, lg: isDrawerMode ? 0 : '4.5rem' }}
        >
          <Text>{convertedValue}</Text>
          {price !== undefined ? (
            <PriceText
              amount={
                {
                  value: price,
                  currency: undefined,
                } as Money
              }
              floating
              minimumFractionDigits={2}
              fontWeight="normal"
            />
          ) : null}
        </Flex>
      )}
    </Flex>
  )
}

export default CartOptionHeader
